import api from 'Services/api'

const operacaoApiService = {
  list() {
    return api.get('/api/operacao/')
  }
}

export default operacaoApiService
